var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestrictedAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 83.747 79.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16742",
    "data-name": "Group 16742",
    transform: "translate(-811 -1536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32472",
    "data-name": "Path 32472",
    d: "M33.276,2A18.276,18.276,0,1,0,51.551,20.276,18.276,18.276,0,0,0,33.276,2Z",
    transform: "translate(796 1534)",
    fill: "#c5ffcb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16741",
    "data-name": "Group 16741",
    transform: "translate(824 1545.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32468",
    "data-name": "Path 32468",
    d: "M24.33,60.246A62.289,62.289,0,0,0,34.5,59.427,18.6,18.6,0,1,0,48.66,32.6V9.269C48.66,3.244,36.125,0,24.33,0S0,3.244,0,9.269V50.977C0,57,12.535,60.246,24.33,60.246Zm0-2.317c-12.976,0-22.013-3.663-22.013-6.951V41.2c4.16,3.363,13.287,5.143,22.013,5.143a63.442,63.442,0,0,0,8.878-.613,18.244,18.244,0,0,0,.341,11.5,60.518,60.518,0,0,1-9.219.7ZM67.2,50.977a16.22,16.22,0,1,1-16.22-16.22A16.22,16.22,0,0,1,67.2,50.977ZM24.33,2.317c12.976,0,22.013,3.663,22.013,6.951S37.306,16.22,24.33,16.22,2.317,12.557,2.317,9.269,11.354,2.317,24.33,2.317ZM2.317,13.394c4.16,3.363,13.287,5.143,22.013,5.143s17.852-1.78,22.013-5.143v9.777c0,3.288-9.037,6.951-22.013,6.951S2.317,26.459,2.317,23.171Zm0,13.9C6.478,30.66,15.6,32.44,24.33,32.44S42.182,30.66,46.343,27.3v5.753a18.585,18.585,0,0,0-12.188,10.2,60.744,60.744,0,0,1-9.825.78c-12.976,0-22.013-3.663-22.013-6.951Z",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32469",
    "data-name": "Path 32469",
    d: "M4.667,19.408c.388.182.8.357,1.225.526a1.158,1.158,0,1,0,.85-2.155q-.572-.226-1.093-.47a1.159,1.159,0,0,0-.982,2.1Z",
    transform: "translate(0.634 2.727)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32470",
    "data-name": "Path 32470",
    d: "M9.9,21.134q.585.138,1.193.26a1.106,1.106,0,0,0,.232.022,1.159,1.159,0,0,0,.232-2.294c-.382-.076-.757-.159-1.124-.243a1.159,1.159,0,1,0-.526,2.256Z",
    transform: "translate(1.424 2.988)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32471",
    "data-name": "Path 32471",
    d: "M41.974,52.881a1.159,1.159,0,0,0,.819.339.8.8,0,0,0,.116-.006,1.159,1.159,0,0,0,.849-.51l9.269-13.9A1.159,1.159,0,0,0,51.1,37.516L42.613,50.244l-3.636-3.636a1.158,1.158,0,1,0-1.638,1.638Z",
    transform: "translate(5.867 5.867)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedAccess);
export default __webpack_public_path__ + "static/media/RestrictedAccess.3fddfdb311182e628f732f66e616b0e8.svg";
export { ForwardRef as ReactComponent };